import { styled, Typography } from "@mui/material"

const Separator = styled(Typography)(() => ({
  margin: "0 8px",
}))

export default Separator
